import { cloneDeep } from 'lodash';
import BaseDropdown from './dropdown';
import { getSelectedString } from '../common/utils';

class PacingIntervalDropdown extends BaseDropdown {
  constructor(props) {
    super(props);

    this.type = 'pacingIntervals';
    this.label = 'Pacing Ranges';
    this.identifierField = 'label';
    this.dropdownDiv = null;
    this.hasSearch = false;

    this.state = {
      opened: false,
      focusIndex: null,
      pacingIntervals: this.props.items,
    };
  }

  update() {
    const newItems = cloneDeep(this.state.pacingIntervals);

    if (!newItems.find(item => item.selected)) {
      newItems.map(item => (item.selected = true));
    }
    this.setState({ pacingIntervals: newItems });
    const selectedItems = getSelectedString(newItems);
    this.AnalyticService.trackEvent(
      this.props.gaEvent.category,
      'Execute',
      `${this.props.gaEvent.label} ${selectedItems}`,
    );

    // Update base-overview with new items
    this.props.updatePacingIntervalOptions(newItems);
  }
}

export default PacingIntervalDropdown;
